import { motion } from 'framer-motion';
import { memo } from 'react';

type StaggeredTextProps = {
  text: string;
  fontSize?: number;
  letterSpacing?: number;
  className?: string;
};

export const StaggeredText = memo(
  ({
    text,
    fontSize = 20,
    letterSpacing = 0.2,
    className = '',
  }: StaggeredTextProps) => {
    const lines = text.split(/\r?\n/).map((line) => line.trim());
    const container = {
      hidden: { opacity: 0 },
      visible: {
        opacity: 1,
        transition: { staggerChildren: 0.03 },
      },
    };

    const child = {
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          type: 'tween',
          duration: 0.4,
          ease: 'easeOut',
        },
      },
      hidden: {
        opacity: 0,
        y: 5,
      },
    };

    return (
      <motion.div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: fontSize / 2,
        }}
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {lines.map((line, lineIndex) => (
          <motion.div
            key={lineIndex}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            {line.split('').map((char, charIndex) => (
              <motion.span
                key={`${lineIndex}-${charIndex}`}
                variants={child}
                style={{
                  fontSize,
                  letterSpacing,
                  display: 'inline-block',
                  whiteSpace: 'pre',
                }}
                className={className}
              >
                {char}
              </motion.span>
            ))}
          </motion.div>
        ))}
      </motion.div>
    );
  }
);
